import classNames from 'classnames'
import { forwardRef, HTMLAttributes, JSX, PropsWithChildren } from 'react'

import { splitSprinkleProps } from '@/styles/split-sprinkle-props'

import { sprinkles, Sprinkles } from '@/styles/sprinkles.css'

export const Flex = forwardRef<HTMLDivElement, FlexProps>(function Flex(props, ref) {
  const [sprinkleProps, { as = 'div', className, style, inline, children, ...restProps }] = splitSprinkleProps<FlexProps>(props)
  const display = inline ? 'inline-flex' : 'flex'
  const As = as as any
  return (
    <As
      ref={ref}
      style={style}
      className={classNames(sprinkles({ ...sprinkleProps, display }), className)}
      {...restProps}
    >
      {children}
    </As>
  )
})

export interface FlexProps extends Omit<Sprinkles, 'display'>, PropsWithChildren, Omit<HTMLAttributes<HTMLElement>, keyof Sprinkles> {
  as?: keyof JSX.IntrinsicElements
  inline?: boolean
}
